import { usePutApiV1ThreeLetterCodeClientAdminsClientAdminUsersId } from '@fukuri-admins/apis/client/gen/endpoints';

export const useEditClientAdminUser = usePutApiV1ThreeLetterCodeClientAdminsClientAdminUsersId;
